import {
  DownOutlined,
  KeyOutlined,
  LogoutOutlined,
  UploadOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  Col,
  Dropdown,
  Form,
  Image,
  Input,
  Modal,
  Row,
  Select,
  Upload as UploadAntd,
  message,
  Tooltip,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { uploadFile } from "react-s3";
import { useNavigate } from "react-router";
import Logo from "../../assets/images/logo.svg";
import notfound from "../../assets/images/not_found.png";
import Notification from "../../assets/images/notification.svg";
import UserImage from "../../assets/images/profile-detail-icon/user-icon02.svg";
import DeleteModal from "../../components/DeleteModal";
import apiPath from "../../constants/apiPath";
import { AuthContext } from "../../context/AuthContext";
import { getFileExtension } from "../../helper/functions";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import { capitalize } from "../../helper/functions";

import { S3Client } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";
import moment from "moment";
import { useAppContext } from "../../context/AppContext";
const s3Config = {
  region: "us-east-1",
  credentials: {
    accessKeyId: "IJTXH751MBXUWMTWM0SF",
    secretAccessKey: "lfTPRJ2PqAxsp3poTW9YlHktgaL1cFkLup8LidW9",
  },
  endpoint: "https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/",
  forcePathStyle: true,
  requestChecksumCalculation: "WHEN_REQUIRED",
  responseChecksumValidation: "WHEN_REQUIRED",
};

const s3Client = new S3Client(s3Config);

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ name: sectionHeading, onPress }) {
  const [visible, setVisible] = useState(false);

  const [profile, setProfile] = useState({});
  const [selected, setSelected] = useState();
  const [profileVisible, setProfileVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [appSettingVisible, setAppSettingVisible] = useState(false);
  const [list, setList] = useState([]);
  const { request } = useRequest();
  const [refresh, setRefresh] = useState(false);
  const { logout, userProfile, isAdmin, setIsAdmin } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const {
    logs,
    logsCount,
    unreadNotiCount,
    notifications,
    setRefreshAppContext,
  } = useAppContext();

  const [form] = Form.useForm();

  const navigate = useNavigate();

  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (!userProfile) return;
    setIsAdmin(true);
  }, [userProfile]);

  useEffect(() => window.scrollTo(0, 0));

  const readAll = () => {
    request({
      url: apiPath.notificationRead,
      method: "POST",
      onSuccess: (data) => {
        setUnreadCount(0);
        setRefreshAppContext((x) => !x);
      },
      onError: (err) => {
        console.log(err);
      },
    });
  };

  const readAllLogs = () => {
    request({
      url: apiPath.logRead,
      method: "PUT",
      onSuccess: (data) => {
        setRefreshAppContext((x) => !x);
      },
      onError: (err) => {
        console.log(err);
      },
    });
  };

  const notificationitems = [
    {
      label: (
        <div className="notification_top">
          <div className="notification-head">
            <h5>Notifications</h5>
          </div>
          <div className="notification-inner">
            {notifications?.map((noti) => (
              <div
                style={{
                  backgroundColor: !noti?.is_read ? "#f3f3f3" : "initial",
                }}
                className="single-notification"
              >
                {/* <div className="notification-img">
                  {noti?.data?.data?.user?.image
                    ? <img src={noti?.data?.data?.user?.image} />
                    : <Avatar style={{ backgroundColor: "#00a2ae", verticalAlign: 'middle' }} className="cap" size={35}>
                      {noti?.data?.data?.user?.name?.charAt(0)}
                    </Avatar>}
                </div> */}
                <div className="notification-cont">
                  <h6>{noti?.title}</h6>
                  <p>{noti?.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="viewAll_notification">
            {unreadNotiCount ? (
              <Button
                onClick={() => {
                  readAll();
                  navigate("/notification");
                }}
                className="btnStyle btn_primary"
              >
                View All
              </Button>
            ) : (
              <div className="notification-cont">
                <p style={{ fontSize: "14px" }}>No Notification Found</p>
              </div>
            )}
          </div>
        </div>
      ),
    },
  ];

  const activityLogs = [
    {
      label: (
        <div className="notification_top">
          <div className="notification-head">
            <h5>Activity Log</h5>
          </div>
          <div className="notification-inner">
            {logs.map((log) => (
              <div
                style={{
                  backgroundColor: !log?.is_read ? "#292929" : "initial",
                }}
                className="single-notification"
              >
                <div className="notification-cont">
                  <h6>
                    {" "}
                    {`${capitalize(log.action)} on ${moment(
                      log.created_at
                    ).format("ll")}`}
                  </h6>
                  <p>
                    {log?.message} By {log?.user_id?.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="viewAll_notification">
            {logs.length ? (
              <Button
                onClick={() => {
                  readAllLogs();
                  navigate("/view-logs");
                }}
                className="btnStyle btn_primary"
              >
                View All
              </Button>
            ) : (
              <div className="notification-cont">
                <p style={{ fontSize: "14px" }}>
                  No Activity found check{" "}
                  <a
                    href="#"
                    onClick={() => {
                      navigate("/view-logs");
                    }}
                  >
                    Old Logs
                  </a>
                </p>
              </div>
            )}
          </div>
        </div>
      ),
    },
  ];



  const items = [
    {
      label: "Edit Profile",
      key: "1",
      icon: <UserOutlined />,
      danger: true,
    },
    {
      label: "Change Password",
      key: "2",
      icon: <KeyOutlined />,
      danger: true,
    },
    {
      label: "Logout",
      key: "3",
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  useEffect(() => {
    if (!isOpen) return document.body.classList.remove("edit-dropdown");
    document.body.classList.add("edit-dropdown");

    return () => {
      document.body.classList.remove("edit-dropdown");
    };
  }, [isOpen]);

  const showDeleteConfirm = (record) => {
    setIsLogoutModalVisible(true);
  };

  const handleMenuClick = (e) => {
    setIsOpen(false);
    if (e.key === "1") navigate("/my-profile");
    if (e.key === "2") navigate("/change-password");
    if (e.key === "3") setIsLogoutModalVisible(true);
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const handleCreate = (values) => {
    onCreate(values);
  };

  const onCreate = (values) => {
    const { old_password, new_password } = values;
    const payload = {};
    if (!old_password || !new_password)
      return ShowToast("Please enter password ", Severty.ERROR);
    setLoading(true);
    payload.new_password = new_password;
    payload.old_password = old_password;
    request({
      url: apiPath.changePassword,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          setVisible(false);
          logout();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
        ShowToast("Logout Successfully", Severty.SUCCESS);
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    request({
      url: apiPath.profile,
      method: "GET",
      onSuccess: (data) => {
        setProfile(data.data);
        console.log(data.data)
        setSelected(data.data);
        form.setFieldValue({
          profileImage: data.data.profileImage,
        })

        if (data.data.profileImage) {
          setImageUrl(data.data.profileImage);
        }
      },

    });
  }, [refresh]);

  return (
    <>
      <Row gutter={[24, 0]} className="justify-content-between mx-0">
        <Col span={24} xs={24} md={24} lg={13} sm={24} className=" px-0">
          <div className="d-none d-lg-block headding-section">
            <h6> Welcome
              {" "}{profile ? profile?.name : "Administrator"}</h6>
            {/* <p>
              Lorem ipsum dolor sit amet consectetur. Duis cursus amet massa
              risus metus congue scelerisque mattis.
            </p> */}
          </div>
          <div className="tabLogo d-sm-block d-lg-none">
            <img className="w-100" src={Logo} />
          </div>
        </Col>
        <Col span={24} xs={24} sm={24} lg={11} className="header-control px-0">
          <Button
            type="link"
            className="sidebar-toggler ps-0"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>
          {/* <div className="notificationDropdownMain">
            <div className="notification-header d-lg-block">
              <Dropdown
                menu={{ items: activityLogs }}
                trigger={["click"]}
                className="notification-box"
              >
                <Tooltip title="Logs">
                  <Button>
                    {logsCount ? (
                      <span className="active_notification">
                        &nbsp;{logsCount || 0}&nbsp;
                      </span>
                    ) : (
                      ""
                    )}
                  </Button>
                </Tooltip>
              </Dropdown>
            </div>
          </div>
          <div className="notificationDropdownMain">
            <div className="notification-header d-lg-block">
              <Dropdown
                menu={{ items: notificationitems }}
                trigger={["click"]}
                className="notification-box"
              >
                <Tooltip title="Notifications">
                  <Button>
                    <img src={Notification} />
                    {unreadNotiCount ? (
                      <span className="active_notification">
                        &nbsp;{unreadNotiCount || 0}&nbsp;
                      </span>
                    ) : (
                      ""
                    )}
                  </Button>
                </Tooltip>
              </Dropdown>
            </div>
          </div> */}

          <div className="profileDropdownMain">
            <Dropdown
              open={isOpen}
              onOpenChange={(open) => setIsOpen(open)}
              className="edit-box"
              menu={menuProps}
              trigger={["click"]}
            >
              <Button className="ant-btn ant-btn-default ant-dropdown-trigger ant-dropdown-open">
                <div className=" d-flex align-items-center gap-2">
                  <div className="userImg">
                    <Image src={imageUrl || UserImage} preview={false} />
                  </div>
                  <div className="d-none d-xl-block">
                    <div className="userName">
                      {profile ? profile?.name : "Administrator"}

                    </div>
                  </div>
                </div>
              </Button>
            </Dropdown>
          </div>
          {isLogoutModalVisible && (
            <DeleteModal
              title={"Logout"}
              subtitle={`Are you sure you want to logout 
                your account?`}
              show={isLogoutModalVisible}
              hide={() => {
                setIsLogoutModalVisible(false);
              }}
              onOk={() => {
                ShowToast("Logout Successfully!", Severty.SUCCESS);
                logout();
                setIsLogoutModalVisible(false);
              }}
            />
          )}
        </Col>
      </Row>
    </>
  );
}

export const AppSetting = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ ...data });
  }, [data]);

  const onAppSetting = (values) => {
    setLoading(true);
    request({
      url: apiPath.updateAppSetting,
      method: "POST",
      data: values,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      width={1200}
      open={show}
      // title={`${data ? "Update App Setting" : ""}`}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
      okText={"Ok"}
      cancelText={"Cancel"}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <h4 className="modal_title_cls">Update App Setting</h4>
      <Form id="create" form={form} onFinish={onAppSetting} layout="vertical">
        <Row gutter={{ xs: [0, 16], md: [16, 0] }}>
          <Col span={24} md={12}>
            <Card title="Android Details">
              <Col span={24}>
                <Form.Item
                  label="App Store URL"
                  name="app_store_url"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the app store URL!",
                    },
                  ]}
                >
                  <Input placeholder="Enter App Store URL" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Version"
                  name="android_version"
                  rules={[
                    { required: true, message: "Please enter the version!" },
                  ]}
                >
                  <Input placeholder="Enter Android Version" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Share Content"
                  name="android_share_content"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the share content!",
                    },
                  ]}
                >
                  <Input.TextArea
                    showCount
                    maxLength={500}
                    style={{ height: 120, marginBottom: 15 }}
                    placeholder="Share Android Content"
                  />
                </Form.Item>
              </Col>
            </Card>
          </Col>

          <Col span={24} md={12}>
            <Card title="IOS Details">
              <Col span={24} className="">
                <Form.Item
                  label="Play Store URL"
                  name="play_store_url"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the play store URL!",
                    },
                  ]}
                >
                  <Input placeholder="Enter Play Store URL" />
                </Form.Item>
              </Col>

              <Col span={24} className="">
                <Form.Item
                  label="Version"
                  name="ios_version"
                  rules={[
                    { required: true, message: "Please enter the version!" },
                  ]}
                >
                  <Input placeholder="Enter IOS Version" />
                </Form.Item>
              </Col>

              <Col span={24} className="">
                <Form.Item
                  label="Share Content"
                  name="ios_share_content"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the share content!",
                    },
                  ]}
                >
                  <Input.TextArea
                    showCount
                    maxLength={500}
                    style={{ height: 120, marginBottom: 15 }}
                    placeholder="Share IOS Content"
                  />
                </Form.Item>
              </Col>
            </Card>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const ChangePassword = ({ show, hide, handleCreate, loading }) => {
  const [form] = Form.useForm();
  return (
    <Modal
      open={show}
      // title="Change password"
      okText={"Ok"}
      cancelText={"Cancel"}
      onCancel={hide}
      //onOk={handleCreate}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <h4 className="modal_title_cls">Change Password</h4>
      <Form id="create" form={form} onFinish={handleCreate} layout="vertical">
        <Form.Item
          label="Old Password"
          name="old_password"
          hasFeedback
          rules={[
            { required: true, message: "Please enter the old password!" },
          ]}
        >
          <Input.Password placeholder="Enter Old Password" />
        </Form.Item>
        <Form.Item
          label="New Password"
          name="new_password"
          dependencies={["old_password"]}
          hasFeedback
          rules={[
            { required: true, message: "Please enter the new password!" },
            {
              pattern: new RegExp(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
              ),
              message:
                "New password at least contain 8 characters, at least contain one capital letter, at least contain one small letter, at  least contain one digit, atleast contain one special character",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("old_password") === value) {
                  return Promise.reject(
                    new Error("Old password & new password must be different!")
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input.Password placeholder="Enter New Password" />
        </Form.Item>
        <Form.Item
          label="Confirm New Password"
          name="confirm_new_password"
          dependencies={["new_password"]}
          hasFeedback
          rules={[
            { required: true, message: "Please enter the confirm password!" },
            {
              pattern: new RegExp(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
              ),
              message:
                "Confirm password atleast contain 8 characters, atleast contain one captital letter, atleast contain one small letter, atleast contain one digit, atleast contain one special character",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Confirm password & password does not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder="Enter Confirm Password" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Header;
